/* eslint-disable no-multi-assign */ /* this is ok in reducers */
import * as types from 'constants/action_types'
import { without } from 'util/arrays'

const defaultState = {}
const reducers = {}

function reduceById(state, mailboxes) {
  const sorted = []
  const byId = state.byId || {}
  const newById = Object.assign({}, byId)
  const sortedMailboxes = mailboxes // just use the API sorting

  if (sortedMailboxes) {
    sortedMailboxes.forEach(mailbox => {
      const newMailbox = { ...mailbox }
      const newFolders = buildFolders(newMailbox, { extractIds: true })

      if (newFolders) {
        newMailbox.folders = newFolders
      }
      newById[newMailbox.id] = newMailbox
      sorted.push(newMailbox.id)
    })
  }

  return {
    ...state,
    byId: newById,
    sorted,
  }
}

reducers[types.UPDATE_APP_DATA] = (state, action) => {
  const { mailboxes } = action.data
  return reduceById(state, mailboxes)
}

reducers[types.FETCH_MAILBOXES_SUCCESS] = (state, { data: { mailboxes } }) => {
  return reduceById(state, mailboxes)
}

function buildFolders(mailbox, { extractIds = false } = {}) {
  if (mailbox.folders) {
    if (extractIds) return mailbox.folders.map(folder => folder.id)
    return mailbox.folders
  }
  return undefined
}

reducers[types.UPDATE_MAILBOX_SUCCESS] = (state, action) => {
  const byId = state.byId || {}
  const { mailbox } = action.payload
  const existingMailbox = byId[mailbox.id]
  const newMailbox = Object.assign({}, existingMailbox || {}, mailbox)
  const newFolders = buildFolders(newMailbox)

  if (newFolders) newMailbox.folders = newFolders

  const newById = {
    ...byId,
    [newMailbox.id]: newMailbox,
  }
  const sorted = state.sorted || []
  let newSorted

  if (sorted.indexOf(newMailbox.id) < 0) {
    newSorted = sorted.concat(newMailbox.id)
  }

  return {
    ...state,
    byId: newById,
    sorted: newSorted || sorted,
  }
}

reducers[types.REMOVE_MAILBOX] = reducers[types.DESTROY_MAILBOX_SUCCESS] = (
  state,
  action
) => {
  const id = action.data
  const byId = state.byId || {}
  const sorted = state.sorted || []
  const newById = Object.assign({}, byId)
  const newSorted = sorted.slice()
  without(newSorted, id)
  delete newById[id]
  return Object.assign({}, state, {
    byId: newById,
    sorted: newSorted,
  })
}

reducers[types.UPDATE_CURRENT_MAILBOX] = (state, action) => {
  const data = action.data
  const mailbox = Object.assign({}, data.currentMailbox)
  if (mailbox.tickets && mailbox.tickets.edges) {
    // flatten the tickets collection
    const ticketsReferences = mailbox.tickets.edges.map(edge => edge.node.id)
    mailbox.tickets = ticketsReferences
  }
  const byId = state.byId || {}
  const newById = Object.assign({}, byId)
  newById[mailbox.id] = mailbox
  return Object.assign({}, state, {
    byId: newById,
  })
}

reducers[types.ADD_CREATED_TICKET] = (state, action) => {
  const data = action.data
  const ticket = data.ticket
  const mailboxId = data.mailboxId
  const byId = state.byId || {}
  const mailbox = byId[mailboxId]
  if (!mailbox) return state
  const newById = Object.assign({}, byId)
  const newMailbox = Object.assign({}, mailbox)
  newMailbox.tickets.push(ticket.id)
  newById[newMailbox.id] = newMailbox
  return Object.assign({}, state, {
    byId: newById,
  })
}

reducers[types.UPDATE_INACCESSIBLE_MAILBOXES] = (state, action) => {
  const data = action.data
  return Object.assign({}, state, {
    inaccessibleMailboxes: data.mailboxes,
  })
}

export default function reducer(state = defaultState, action) {
  // this is here because a long reducer with many ifs is unreadable
  const handler = reducers[action.type]
  if (handler) return handler(state, action)
  return state
}
